module.exports = __webpack_public_path__ + "img/MemeETC (2).25f3183e.jpeg";